import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import SEO from "../components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/news/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-[60svh] pt-32 px-6 text-center">
        <h1 className="font-display text-4xl">Articolo non trovato</h1>
        <Link
          to="/news"
          className="mt-6 inline-block text-white/60 hover:text-white"
        >
          ← Torna agli articoli
        </Link>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="min-h-[60svh] pt-32 px-6 text-center text-white/40">
        Caricamento…
      </div>
    );
  }

  return (
    <div data-testid="news-detail-page" className="pt-28">
      <SEO
        title={article.title}
        path={`/news/${article.slug}`}
        description={article.excerpt || article.title}
        image={article.cover}
        type="article"
      />
      <article className="relative">
        <div className="relative aspect-[16/8] md:aspect-[21/9] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${article.cover})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#08080A] via-black/40 to-transparent" />
        </div>

        <div className="relative -mt-24 md:-mt-32 px-6 md:px-12 max-w-3xl mx-auto">
          <Link
            to="/news"
            data-testid="news-back"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white"
          >
            <ArrowLeft size={14} /> Tutti gli articoli
          </Link>
          <div className="mt-6 flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-[#C48F56] font-mono">
            {article.category}
            <span className="h-1 w-1 rounded-full bg-white/20" />
            {new Date(article.date).toLocaleDateString("it-IT", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}
            <span className="h-1 w-1 rounded-full bg-white/20" />
            {article.read_time}
          </div>
          <h1 className="mt-5 font-display text-5xl md:text-6xl lg:text-7xl tracking-tightest leading-[0.95]">
            {article.title}
          </h1>
          <p className="mt-6 text-xl text-white/70 leading-relaxed italic font-display">
            {article.excerpt}
          </p>
          <div className="mt-5 text-sm text-white/40">
            di {article.author}
          </div>
        </div>

        <div className="relative px-6 md:px-12 max-w-2xl mx-auto py-16 space-y-7">
          {article.body.map((para, i) => (
            <p key={i} className="text-white/80 text-lg leading-[1.75]">
              {para}
            </p>
          ))}
        </div>
      </article>
    </div>
  );
}
